export default "<p-panelMenu [model]=\"items\" [style]=\"{ width: '100%' }\"></p-panelMenu>\n"